
(function() {
    'use strict';
    
    angular
    	.module('serviciosocialApp')
    	.factory('CertificadoDownloadService', CertificadoDownloadService);

    CertificadoDownloadService.$inject = ['$q','$http'];
    
        function CertificadoDownloadService($q, $http) {
        	return {
        		download: download
        	}
        			
        	function download(idAsignacion, numRecibo, matricula) {
            
	        	var defer = $q.defer();
	                
	            $http({
					url: 'api/s-s-asignacions/certificacion/'+ idAsignacion + "/" + numRecibo,
					method : 'POST',
					params : {},
					headers : {
						'Content-type' : 'application/octet-stream',
					},
					responseType : 'arraybuffer'
	            }).success(function(data, status, headers, config) {
					var file = new Blob([ data ], {
						type : 'application/pdf'
					});
					//trick to download store a file having its URL
					var fileURL = URL.createObjectURL(file);
					var a         = document.createElement('a');
					a.href        = fileURL; 
					a.target      = '_blank';
					a.download    = "CertificadoServicioSocial_" + matricula;
					document.body.appendChild(a);
					a.click();
					defer.resolve('success');
					console.log(data);
	            }).error(function() {
					defer.reject('error');
				});
	            return defer.promise;
	        };
        }
})();